import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Modal, Form, Input, Button, notification, Typography, Result } from 'antd'
import axios from 'axios'
import config from 'envVariables'
import actions from 'redux/home/actions'
import NavigationItem from './NavigationItem'

const { Paragraph } = Typography

const Navigation = () => {
  const demo = useSelector((state) => state.home.demo)

  const dispatch = useDispatch()

  const [loading, setLoading] = React.useState(false)
  const [isSuccess, setIsSuccess] = React.useState(false)

  const handleDemoCancel = () => {
    dispatch({
      type: actions.SET_STATE,
      payload: { demo: false },
    })
    setTimeout(() => {
      setIsSuccess(false)
      setLoading(false)
    }, 300)
  }

  const onFinish = async (values) => {
    setLoading(true)
    try {
      const payload = {
        ...values,
        company: values.company?.trim(),
        email: values.email?.trim(),
        use_case: values.use_case?.trim(),
      }
      await axios.post(`${config.baseURL}public/demo-request`, payload)

      setIsSuccess(true)
    } catch (err) {
      notification.error({
        message: 'Failed to send request',
        description: 'Please try again later or contact us directly.',
      })
    }
    setLoading(false)
  }

  return (
    <>
      <Modal centered width={500} open={demo} onCancel={handleDemoCancel} footer={null} title={isSuccess ? null : "PY Insights Demo Request"}>
        {isSuccess ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
            <Result
              status="success"
              title="Demo Request Sent!"
              subTitle="Thank you for your interest. We will be in touch shortly."
              extra={[
                <Button type="primary" key="close" onClick={handleDemoCancel} style={{ background: '#222222', borderColor: '#222222', minWidth: 120 }}>
                  Close
                </Button>
              ]}
            />
          </div>
        ) : (
          <div style={{ padding: '0 10px' }}>
            <Paragraph style={{ marginBottom: 16, fontSize: '14px' }}>
              Welcome - tell us a bit more about your interest and we'll be in touch!
            </Paragraph>
            <Form layout="vertical" onFinish={onFinish}>
              <Form.Item name="company" label={<span style={{ fontWeight: 500 }}>Company name</span>} rules={[{ required: true, whitespace: true, min: 2, message: 'Please enter a valid company name (min 2 characters)' }]}>
                <Input placeholder="Please enter your company name" />
              </Form.Item>
              <Form.Item name="email" label={<span style={{ fontWeight: 500 }}>Your work email address</span>} rules={[{ required: true, type: 'email', message: 'Please enter your work email address' }]}>
                <Input placeholder="Please enter your work email address" />
              </Form.Item>
              <Form.Item name="use_case" label={<span style={{ fontWeight: 500 }}>What would you like to find out about?</span>} rules={[{ required: true, whitespace: true, min: 5, message: 'Please tell us how we can help (min 5 characters)' }]}>
                <Input.TextArea autoSize={{ minRows: 4, maxRows: 6 }} placeholder="How can we help" />
              </Form.Item>
              <Form.Item style={{ marginTop: 24, marginBottom: 0 }}>
                <Button type="primary" htmlType="submit" loading={loading} block style={{ background: '#222222', borderColor: '#222222', height: 40, fontSize: '15px' }}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </div>
        )}
      </Modal>

      <nav className="ctf-nav">
        <Link className="ctf-nav-logo" to="/">
          <img
            className="ctf-nav-logo-img-light"
            src="resources/images/pyi-logo.png"
            alt="Powr of you"
          />
        </Link>
        <ul className="ctf-nav-list">
          <NavigationItem href="/">Solutions</NavigationItem>
          <NavigationItem href="/">Clients</NavigationItem>
          <NavigationItem href="/demo">Demo</NavigationItem>
          <NavigationItem href="/login">Log in</NavigationItem>
          <NavigationItem href="/signup">Sign up</NavigationItem>
          <NavigationItem href="/">Contact us</NavigationItem>
        </ul>
        <button
          type="button"
          className="ctf-nav-toggle"
          onClick={() => {
            document.querySelector('.ctf-nav-toggle').classList.toggle('ctf-nav-toggle-open')
            document.querySelector('.ctf-nav-list').classList.toggle('ctf-nav-list-open')
          }}
        >
          <span>Toggle Menu</span>
        </button>
      </nav>
    </>
  )
}

export default Navigation
